// frontend/app/src/features/feedback/api/feedback.api.js
import api from '@shared/api/api';

export const feedbackApi = {
  submitBugReport: (data) => api.post('/website/feedback/bug-report/', data),
  submitSuggestion: (data) => api.post('/website/feedback/suggestion/', data),
  submitRatingApplication: (data) => api.post('/website/feedback/rating-application/', data),
  submitPositionApplication: (data) => api.post('/website/feedback/position-application/', data),
};
